import { render, staticRenderFns } from "./TaskBlockCommentChild.vue?vue&type=template&id=d9ccb0aa&scoped=true&"
import script from "./TaskBlockCommentChild.vue?vue&type=script&lang=js&"
export * from "./TaskBlockCommentChild.vue?vue&type=script&lang=js&"
import style0 from "./TaskBlockCommentChild.vue?vue&type=style&index=0&id=d9ccb0aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ccb0aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9ccb0aa')) {
      api.createRecord('d9ccb0aa', component.options)
    } else {
      api.reload('d9ccb0aa', component.options)
    }
    module.hot.accept("./TaskBlockCommentChild.vue?vue&type=template&id=d9ccb0aa&scoped=true&", function () {
      api.rerender('d9ccb0aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Task/TaskBlockCommentChild.vue"
export default component.exports